// extracted by mini-css-extract-plugin
module.exports = {"details":"Details_details__xhs96","box":"Details_box__2k13K","row":"Details_row__2Ylf2"};